'use strict';

// @see https://inclusive-components.design/collapsible-sections/

import mergeOpts from "./merge-opts";
import ToggleButton from "./ToggleButton";
import ToggleArea from "./ToggleArea";
import ButtonBehavior from "./ToggleArea_ButtonBehavior";
import SizeTransitionBehavior from "./ToggleArea_SizeBehavior";
import AccordionBehavior from "./ToggleArea_AccordionBehavior";

const _ = new WeakMap();

export default function Accordion(titles, options) {

    const o = mergeOpts({
        name: 'section',
        openFirst: true,
    }, options);

    _.set(this, o);

    o.titles = titles;
    o.ready = null;
}

Accordion.prototype.init = function () {
    const o = _.get(this);
    const accordionBehavior = new AccordionBehavior();
    o.ready = Promise.all(
        Array.prototype.map.call(o.titles, (title, index) => {
            return (new ToggleButton(title))
                .init()
                .then(toggleButton => {
                    return (new ToggleArea(title.nextElementSibling, o.name, [
                        new ButtonBehavior(toggleButton.button(), {
                            closeOnEsc: false,
                            closeOnLinkClick: false,
                            closeOnOutsideClick: false,
                            openedOnInit: o.openFirst && index === 0,
                            jail: false,
                        }),
                        new SizeTransitionBehavior(),
                        accordionBehavior,
                    ])).ready().then(toggleArea => {
                        return {toggleButton, toggleArea};
                    });
                });
        })
    );
    return o.ready.then(() => this);
}

Accordion.prototype.destroy = function () {
    const o = _.get(this);
    _.delete(this);
    return o.ready.then(tuples => {
        return Promise.all(
            tuples.map(({toggleButton, toggleArea}) => {
                return Promise.all([
                    toggleButton.destroy(),
                    toggleArea.destroy(),
                ]);
            })
        );
    })
}